import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {WeChatMessageTemplateDto} from "../dto/WeChatMessageTemplateDto";
import {WeChatMessageTemplateSearchCondition} from "../dto/WeChatMessageTemplateSearchCondition";

export const WeChatMessageTemplateApi = {

    queryMessageTemplates: async (body: WeChatMessageTemplateSearchCondition) => {
        try {
            const requestUrl = '/v1/wechat/message/template/query';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getMessageTemplateDetail: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/wechat/message/template/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createMessageTemplate: async (body: WeChatMessageTemplateDto) => {
        try {
            const requestUrl = '/v1/wechat/message/template/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateMessageTemplate: async (body: WeChatMessageTemplateDto) => {
        try {
            const requestUrl = '/v1/wechat/message/template/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteMessageTemplate: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/wechat/message/template/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
